<template>
  <v-layout row wrap mb-4 pa-4>
    <case-header></case-header>
    <v-flex xs12>
      <v-card class="pa-4">
        <p>
          Add a team or an individual to this case.
          <strong>Note:</strong> You can click a team icon to view all members in a team.
        </p>
        <ParticipantsPanel
          :available-users="availableUsers"
          :available-teams="availableTeams"
          :participating-users="participatingUsers"
          :participating-teams="participatingTeams"
          v-on:pending-update="updateData"
        ></ParticipantsPanel>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import CaseHeader from "@/components/cases/case-edit/CaseHeader.vue"
import ParticipantsPanel from "@/components/ParticipantsPanel.vue"
import { mapState } from "vuex"

export default {
  name: "case-participants",
  data: () => ({
    hasSaved: false,
    hasDeleted: false,
    usersReady: false,
    teamsReady: false,
    dialogDelete: false,
    pendingAddUsers: [],
    pendingAddTeams: [],
    pendingRemoveUsers: [],
    pendingRemoveTeams: []
  }),
  components: { CaseHeader, ParticipantsPanel },
  computed: {
    ...mapState({
      currentCaseId: state => state.cbroute.params.case_id,
      currentCase: state =>
        state &&
        state.cases &&
        state.cases.currentlySelected.case
          ? state.cases.currentlySelected.case
          : {},
      availableUsers: state =>
        state &&
        state.users &&
        state.users.all
          ? state.users.all
          : [],
      availableTeams: state =>
        state &&
        state.teams &&
        state.teams.all
          ? state.teams.all
          : [],
      participatingUsers: state =>
        state &&
        state.cases.currentlySelected &&
        state.cases.currentlySelected.case &&
        state.cases.currentlySelected.case.participantUsers
          ? state.cases.currentlySelected.case.participantUsers
          : [],
      participatingTeams: state =>
        state &&
        state.cases.currentlySelected &&
        state.cases.currentlySelected.case &&
        state.cases.currentlySelected.case.participantTeams
          ? state.cases.currentlySelected.case.participantTeams
          : []
    })
  },
  methods: {
    async updateData(data) {
      this.handlePendingAddUsers(data.pendingAddUsers)
      this.handlePendingRemoveUsers(data.pendingRemoveUsers)
      this.handlePendingAddTeams(data.pendingAddTeams)
      this.handlePendingRemoveTeams(data.pendingRemoveTeams)
    },
    handlePendingAddUsers(pendingUsers) {
      const adds = []
      const rems = []
      // Find Missing users
      this.pendingAddUsers.forEach(existingUser => {
        if (!pendingUsers.includes(existingUser)) {
          rems.push(existingUser)
          const index = this.pendingAddUsers.indexOf(existingUser)
          this.pendingAddUsers.splice(index, 1)
        }
      })
      // Find New users
      pendingUsers.forEach(pendingUser => {
        if (!this.pendingAddUsers.includes(pendingUser)) {
          adds.push(pendingUser)
          this.pendingAddUsers.push(pendingUser)
        }
      })
      // Perform add and removes
      rems.forEach(user => {
        this.removeUser(user)
      })
      adds.forEach(user => {
        this.addUser(user)
      })
    },
    handlePendingRemoveUsers(pendingUsers) {
      const adds = []
      // Remove Missing users
      this.pendingRemoveUsers.forEach(existingUser => {
        if (!pendingUsers.includes(existingUser)) {
          const index = this.pendingRemoveUsers.indexOf(existingUser)
          this.pendingRemoveUsers.splice(index, 1)
        }
      })
      // Find New users
      pendingUsers.forEach(pendingUser => {
        if (!this.pendingRemoveUsers.includes(pendingUser)) {
          adds.push(pendingUser)
          this.pendingRemoveUsers.push(pendingUser)
        }
      })
      // Perform removes
      adds.forEach(user => {
        this.removeUser(user)
      })
    },
    handlePendingAddTeams(pendingTeams) {
      const adds = []
      const rems = []
      // Find Missing teams
      this.pendingAddTeams.forEach(existingTeam => {
        if (!pendingTeams.includes(existingTeam)) {
          rems.push(existingTeam)
          const index = this.pendingAddTeams.indexOf(existingTeam)
          this.pendingAddTeams.splice(index, 1)
        }
      })
      // Find New teams
      pendingTeams.forEach(pendingTeam => {
        if (!this.pendingAddTeams.includes(pendingTeam)) {
          adds.push(pendingTeam)
          this.pendingAddTeams.push(pendingTeam)
        }
      })
      // Perform add and removes
      rems.forEach(team => {
        this.removeTeam(team)
      })
      adds.forEach(team => {
        this.addTeam(team)
      })
    },
    handlePendingRemoveTeams(pendingTeams) {
      const adds = []
      // Remove Missing teams
      this.pendingRemoveTeams.forEach(existingTeam => {
        if (!pendingTeams.includes(existingTeam)) {
          const index = this.pendingRemoveTeams.indexOf(existingTeam)
          this.pendingRemoveTeams.splice(index, 1)
        }
      })
      // Find New teams
      pendingTeams.forEach(pendingTeam => {
        if (!this.pendingRemoveTeams.includes(pendingTeam)) {
          adds.push(pendingTeam)
          this.pendingRemoveTeams.push(pendingTeam)
        }
      })
      // Perform removes
      adds.forEach(team => {
        this.removeTeam(team)
      })
    },
    addUser(pendingUser) {
      this.$store.dispatch("addParticipantToCase", {
        participant: pendingUser,
        type: "user",
        caseId: this.currentCaseId
      })
    },
    removeUser(pendingUser) {
      this.$store.dispatch("removeParticipantFromCase", {
        participant: pendingUser,
        type: "user",
        caseId: this.currentCaseId
      })
    },
    addTeam(pendingTeam) {
      this.$store.dispatch("addParticipantToCase", {
        participant: pendingTeam,
        type: "team",
        caseId: this.currentCaseId
      })
    },
    removeTeam(pendingTeam) {
      this.$store.dispatch("removeParticipantFromCase", {
        participant: pendingTeam,
        type: "team",
        caseId: this.currentCaseId
      })
    }
  }
}
</script>
